@if (params) {
  <lib-input-content-view
    [views]="views"
    [selected]="(params.selectedView$ | async) ?? 'results'"
    (selectedChange)="params.selectedView$.next($event)"
    [createTemplate]="createTemplate"
    [editTemplate]="editTemplate"
    [resultTemplate]="resultTemplate">
  </lib-input-content-view>
  <ng-template #resultTemplate>
    @if ({ index: params.highlightedIndex$ | async }; as highlighted) {
      @if (params.filteredEntities$ | async; as products) {
        <ul class="w-full h-full my-0" >
          @for (entity of products; track trackByFn(i, entity); let last = $last; let i = $index) {
            <li
              [scrollIntoView]="highlighted.index === i"
              (mouseenter)="params.highlightedIndex$.next(i)"
              (mouseleave)="params.highlightedIndex$.next(-1)"
              [class.bg-secondary-200]="highlighted.index === i"
              (click)="close(entity)"
              [ngClass]="!last ? 'border-b border-solid' : ''"
              class="pl-2 w-full !flex flex-col">
              <ng-container *ngTemplateOutlet="(params.entityResultTemplate$ | async); context: { $implicit: entity, highlighted: highlighted.index === i }"></ng-container>
            </li>
          }
        </ul>
      }
    }
  </ng-template>
  <ng-template #editTemplate>
    @if ({ product: params.entityInEditing$ | async }; as productInEditing) {
      <ng-container *ngTemplateOutlet="(params.entityEditTemplate$ | async); context: { $implicit: $safeNavigationMigration(productInEditing?.product) }"></ng-container>
    }
  </ng-template>
  <ng-template #createTemplate>
    <ng-container *ngTemplateOutlet="params.entityCreateTemplate$ | async"></ng-container>
  </ng-template>
}

